const breakpoints = {
  short: "(max-height: 700px)",
  sm: "27em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em",
};

export default breakpoints;
